export default __webpack_public_path__ + "b61f162b7321740e6ba8393913fe7a55.png";